export class ClientLog {
    httpStatus: number;
    exceptionMessage: string;
    stackTrace: string;
    path: string;
}